import 'whatwg-fetch';

import {
    ENDPOINT_MACHINES,
    ENDPOINT_MACHINES_UPDATED,
    ENDPOINT_DISTANCE_MATRIX
} from '../constants/apiEndpoints';

import {
    sortByDistance
} from '../utils/sortByDistance';

export function getMachines() {
    let timestamp = 0;

    const excludeMachineIds = ['B312CB31EE867C85887CD9A73E2D427D'];

    return fetch(ENDPOINT_MACHINES, {
        method: 'get'
    })
        .then(response => {
            timestamp = response.headers.get('Timestamp');
            return response.json();
        })
        .then(json => {
            const filteredJson = json.filter(
                item => !excludeMachineIds.includes(item.identifier)
            );
            return {
                status: 'ok',
                data: filteredJson,
                timestamp: timestamp
            };
        })
        .catch(function (error) {
            return {
                status: 'error',
                message: error.message
            };
        });
}

export function getMachinesUpdated(requestTimestamp) {
    let timestamp = 0;
    return fetch(
        `${ENDPOINT_MACHINES_UPDATED}&last_updated=${requestTimestamp}`,
        {
            method: 'get'
        }
    )
        .then(response => {
            timestamp = response.headers.get('Timestamp');
            return response.json();
        })
        .then(json => {
            return {
                status: 'ok',
                data: json,
                timestamp: timestamp
            };
        })
        .catch(function (error) {
            return {
                status: 'error',
                message: error.message
            };
        });
}

export function getDistanceMatrixClosestItem(userPos, items) {
    if (!userPos) {
        return {
            status: 'ok',
            data: {
                closestItem: []
            },
        };
    }

    let sortedFilteredItems = sortByDistance({
        x: userPos.lng,
        y: userPos.lat
    }, items);


    sortedFilteredItems = sortedFilteredItems.slice(0, 24);

    const destinations = sortedFilteredItems.map(item => [
        parseFloat(item.point.coordinates[1]),
        parseFloat(item.point.coordinates[0]),
    ]);


    return fetch(ENDPOINT_DISTANCE_MATRIX, {
        method: 'post',
        headers: {
            'Content-Type': 'application/json',
        },
        body: JSON.stringify({
            destinations,
            origins: [
                [userPos.lat, userPos.lng]
            ],
        })
    })
        .then(response => {
            return response.json();
        })
        .then(json => {
            const rows = json.rows[0].elements;
            let enumeratedRows = rows.map((row, index) => {
                return { index: index, row };
            });

            enumeratedRows = enumeratedRows.filter(
                ({ row }) => row.status === 'OK'
            );
            enumeratedRows.sort(({ row: rowA }, { row: rowB }) => {
                return rowA.duration.value - rowB.duration.value;
            });

            let closestIndex = 0;

            if (enumeratedRows.length) {
                closestIndex = enumeratedRows[0].index;
            }

            const closestItem = sortedFilteredItems[closestIndex];

            return {
                status: 'ok',
                data: {
                    closestItem: closestItem
                },
            };
        })
        .catch(function (error) {
            return {
                status: 'error',
                message: error.message
            };
        });
}
